// extracted by mini-css-extract-plugin
module.exports = {"CustomOverlay":"CustomWithSpinner_CustomOverlay__3S01j","SpinnerContainer":"CustomWithSpinner_SpinnerContainer__2emTC"};